import { ActionType } from 'typesafe-actions';
import { Enterprise } from '../auth';
import { Contract, ContractType } from '../contracts';
import { Project } from '../projects';
import * as actions from './actions';

export type ChangeOrdersAction = ActionType<typeof actions>;

export interface ChangeOrdersState {
  changeOrders: {
    data: ChangeOrder[] | null;
    loading: boolean;
    error: Error | null;
  };
  changeOrder: {
    data: ChangeOrder | null;
    loading: boolean;
    error: Error | null;
  };
}

export interface ChangeOrder {
  id: number;
  projectId?: string;
  contractId?: string;
  project: Partial<Project>;
  enterprise: Partial<Enterprise>;
  contract: Partial<Contract>;
  title: string;
  type: ContractType;
  status: ChangeOrderStatus;
  changeDate: string;
  description: string;
  attachFilePath: string;
  createdAt: string;
  updatedAt: string;
  file: any[];
  sov: any;
  sovTotal: number;
  priceData: any;
}

export interface ChangeOrderSOV {
  id: number;
  projectId?: string;
  contractId?: string;
  project: Partial<Project>;
  changeOrder: Partial<ChangeOrder>;
  contract: Partial<Contract>;
  contractType1: ContractType;
  editable: boolean;
  quantity: number;
  materialCost: number;
  laborCost: number;
  expense: number;
  materialCostTotal: number;
  laborCostTotal: number;
  expenseTotal: number;
  total: number;
  contractSovId?: any;
}

export interface ChangeOrderMatchParams {
  projectId: string;
  changeOrderId: string;
}

export const changeOrderStatusEnum = {
  DRAFT: '1',
  OUT_FOR_SIGNATURE: '1',
  COMPLETED: '2',
  TERMINATED: '3',
} as const;
export type ChangeOrderStatus =
  (typeof changeOrderStatusEnum)[keyof typeof changeOrderStatusEnum];

export const changeOrderStatusKorean = {
  '0': '작성중',
  '1': '계약 진행중',
  '2': '계약체결',
  '3': '계약종료',
} as const;
